import {useState,useEffect} from "react";
import { Link } from "react-router-dom";
import "../../style/scss/App.scss";

export default function EmployerRecruitListItem(props) {
   //console.log("EmployerListItem props: ",props);
   //console.log("key",props.employment.id);
   let count = props.data.JobPostings.filter((jp) => (jp.EmployerID || 0) === props.employer.id).length;
   //let url = props.employer.EmployerAdminRoles.length>0?"/employerRecruitEdit/":"/employerEdit/";
   return (
      <li key={props.employer.ID}>
         <Link
            to={{
               pathname: "/employerRecruitEdit/" + props.employer.ID,
               state: { breadcrumb: props.breadcrumb },
            }}
            className="centered skillLink"
         >
            <div className="Job mobilePanel">
               <span className="title">{props.employer.Name}</span>
               <span className="byline"></span>
               <span className="rightText">{count} active posts</span>
               <ul>
                  <li></li>
               </ul>
            </div>
         </Link>
      </li>
   );
}


